import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser } from '../helpers/userHelpers';
import { routes } from '../config/config';

const AdminGuard = ({ children }) => {
  const user = getUser();

  if (!user) {
    return <Navigate to={routes.landing} replace />;
  }

  if (!user.isAdmin) {
    return <Navigate to={routes.app} replace />;
  }

  return children;
};

export default AdminGuard;
